export const AI_SUMMARY_REVIEW_COUNT_THRESHOLD = 1000
